import { render, staticRenderFns } from "./PartnerLocatorItem.vue?vue&type=template&id=30133376"
import script from "./PartnerLocatorItem.vue?vue&type=script&lang=js"
export * from "./PartnerLocatorItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {PartnerTypeBadges: require('/app/components/PartnerTypeBadges.vue').default})
